<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="assignationForm" @submit="submitAssign" :validation-schema="assignationSchema">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane"
              type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Information générale</button>
          </li>
          <!-- <li class="nav-item" role="presentation">
            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane"
              type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Méta data</button>
          </li> -->
        </ul>
        <div class="tab-content" id="myTabContent ">
          <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                   Arrondissement <span class="text-danger">*</span>
                  </label>
                  <Field name="arrondissements"  v-slot="{ field }">
                    <Multiselect :options="arrondissementOptions" :searchable="true" multiple="false" data-mode="arrondissements"
                      track-by="value" label="label" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner l'arrondissement" @change="onArrondissementChange" />
                  </Field>
                  <ErrorMessage name="arrondissements" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Mandatures <span class="text-danger">*</span>
                  </label>
                  <Field name="mandatures" v-slot="{ field }">
                    <Multiselect :options="mandaturesOptions" :searchable="true" multiple="false" data-mode="mandatures"
                      track-by="label" label="label" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner la mandature" />
                  </Field>
                  <ErrorMessage name="mandatures" class="text-danger" />
                </div>
              </div>

            </div>
            <div v-if="quartiers?.length > 0" class="col-md-12">
              <h5>Liste des quartiers :</h5>
              <div class="row g-2">
                <!-- {{ postes }} -->
                <div v-for="quartier in quartiers" :key="quartier.id" class="col-md-6">
                  <div class="modal fade" :id="`addMemberModal_${quartier.id}`" tabindex="-2" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="max-width: 600px;">
                  <div class="modal-content">
                    <!-- Header -->
                    <div class="modal-header justify-content-center text-center border-0 ">
                      <h5 class="modal-title" style="text-decoration: underline;">Formulaire d'ajout d'un membre</h5>
                      <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button> -->
                    </div>
                    <!-- Body -->
                    <div class="modal-body">
                      <div class="row justify-content-center">
                        <div class="col-md-8 mb-3">
                          <label class="form-label">Nom :</label>
                          <input type="text" class="form-control" v-model="quartier.membre.nom" placeholder="Entrez un nom">
                        </div>
                        <div class="col-md-8 mb-3">
                          <label class="form-label">Prénom :</label>
                          <input type="text" class="form-control" v-model="quartier.membre.prenom" placeholder="Entrez un prénom">
                        </div>
                        <div class="col-md-8 mb-3">
                          <label class="form-label">Image :</label>
                          <input type="file" class="form-control" @input="(e)=>onImageChange(quartier, e)" >
                           
                        </div>
                      </div>
                      <!-- Footer -->
                      <div class="modal-footer justify-content-center">
                        <button type="button" class="btn btn-primary" @click="addNewMembre(quartier)">Ajouter le membre</button>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <strong>{{ quartier.libelle }}</strong>
                    <button type="button" class="btn btn-sm btn-warning align-self-start"
                      style="color: white; font-size: 10px;" data-bs-toggle="modal" :data-bs-target="`#addMemberModal_${quartier.id}`" @click="currentQuartierId = quartier.id">
                      + Ajouter un membre
                    </button>
                  </div>

                  <div class="d-flex flex-column gap-1">
                    <!-- <Field name="Membre" v-slot="{ field }"> -->
                    <Multiselect :options="membresOptions" :searchable="true" :multiple="false" data-mode="membres"
                      track-by="value" label="label" v-model="quartier.selectedMembre"
                      placeholder="Sélectionner un membre" />
                    <!-- </Field> -->
                    <ErrorMessage name="membres" class="text-danger" />
                  </div>

                </div>
              </div> 
            </div>



          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex align-items-center ">
              <button
                class="default-btn me-20 transition border-0 fw-medium 
                  text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35
                   pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
               Ajouter
              </button>
              <router-link to="/liste-chefquartier" 
                    class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                    <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>

      </Form>

    </div>

  </div>
</template>

<script lang="ts">
import Multiselect from "@vueform/multiselect";
import { Form, Field, ErrorMessage } from "vee-validate";
import { defineComponent, onMounted, reactive, ref, watch } from "vue";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import { PostMembreMandature } from "@/models/postemembremandature";
import { Postes } from "@/models/Postes"
import ApiService from "@/services/ApiService";
import axios from "axios";
import Swal from 'sweetalert2'
import { Modal } from "bootstrap";
import { Reactive } from "vue";
import { Chefquartier } from "@/models/Chefquartier";

export default defineComponent({
  name: "submitAssign",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: (props, { emit }) => {
      const assignationSchema = Yup.object().shape({
      arrondissements: Yup.string().required("L’arrondisement est obligatoire"),
      mandatures: Yup.string().required("La mandature est obligatoire"),
      
    });
    const assignationForm = ref<Chefquartier | null>(null)
    const router = useRouter();
    const arrondissementOptions = ref([]);
    interface MembreOption {
      value: number;
      label: string;
      nom: string;
      prenom: string;
      urlImage?: string | null;
      isTemporary?: boolean;
      file?: File | null;
    }
    
    const currentQuartierId = ref<number | null>(null);
    const membresOptions = ref<MembreOption[]>([]);
    const mandaturesOptions = ref([]);
    const quartiers = ref<Array<{ id: number; libelle: string, selectedMembre: any | null, membre: {
            nom: string,
            prenom: string,
            urlImage: File | null
          } }>>([]);
    const selectedArrondissement= ref<null | {
      value: number;
      label: string;
      quartiers: Array<{ id: number; libelle: string; }>;
    }>(null);
    const nom = ref("");
    const prenom = ref("");
    const newImage = ref<File | null>(null);

    onMounted(() => {
        fetchArrondissement();
        fetchMandatures();
        fetchMembres();
    })

    const fetchArrondissement= async () => {
        try{
            const response= await ApiService.get('/arrondissements');
            console.log("responseeeeeeee", response);
            const arrondissementData= response.data.data.data;
            arrondissementOptions.value= arrondissementData.map((arrondissements) =>({
                value: arrondissements.id,
                label: `${arrondissements.libelle}`,
                quartiers: arrondissements.quartiers || []
            }))
        }catch (error) {
        //
      }
    }

    const fetchMandatures = async () => {
      try {
        const response = await ApiService.get('/mandature');
        console.log("Mandature response", response);
        const mandatureData = response.data.data.data;
        mandaturesOptions.value = mandatureData.map((mandatures) => ({
          value: mandatures.id,
          label: `${mandatures.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchMembres = async () => {
      try {
        const response = await ApiService.get('/membre');
        console.log("Membre response", response);
        const membreData = response.data;
        membresOptions.value = membreData.map((membres) => ({
          value: membres.id,
          label: `${membres.nom} ${membres.prenom}`,

        }));

      } catch (error) {
        //
      }
    }

    const onArrondissementChange = (arrondissementId: any) => {
      const selected = (arrondissementOptions.value as any[]).find(a => a.value === arrondissementId);
      if (selected) {
        selectedArrondissement.value = selected;
        quartiers.value = selected.quartiers.map((q: any) => reactive({
          id: q.id,
          libelle: q.libelle,
          selectedMembre: null,
          membre: {
            nom: null,
            prenom: null,
            urlImage: null
          }
        }));
      } else {
        quartiers.value = [];
      }
    };

    const onImageChange = (quartier: any, event: Event) => {
      const target = event.target as HTMLInputElement;
      if (!target || !target.files || target.files.length === 0) {
        quartier.membre.urlImage = null;
        console.log(`❌ Aucun fichier sélectionné pour quartier ${quartier.id}`);
        return;
      }
      
      const file = target.files[0];
      quartier.membre.urlImage = file;
      console.log(`✅ Fichier sélectionné pour quartier ${quartier.id}:`, {
        name: file.name,
        size: file.size,
        type: file.type
      });
    };
    const addNewMembre = (quartier: any) => {
      if (!quartier.membre.nom || !quartier.membre.prenom) {
        Swal.fire({
          title: "Remplissez les champs",
          icon: "error",
          draggable: true,
        });
        return;
      }
       
      const newMembreObj: any = {
        value: -quartier.id,
        label: `${quartier.membre.nom} ${quartier.membre.prenom}`,
      };
      membresOptions.value.push(newMembreObj);
      quartier.selectedMembre= -quartier.id;


      // Fermer le modal
      const modalEl = document.getElementById('addMemberModal_'+quartier.id);
      if (modalEl) {
        const modalInstance = Modal.getInstance(modalEl) || new Modal(modalEl);
        modalInstance.hide();
      }

      Swal.fire({
        title: "Membre ajouté temporairement",
        icon: "success",
        draggable: true,
      });
    }

    const submitAssign = async (values, { resetForm }) =>{
      try{
        const mandatureId = values.mandatures;
        const arrondissementId = values.arrondissements;
        let payload = {};

        const assignations = quartiers.value.map((q) => {
           if(parseInt(q.selectedMembre) > 0) {
            return {
              quartierId: q.id,
              membre: {
                id: q.selectedMembre,
                nom: q.membre.nom,
                prenom: q.membre.prenom,
                urlImage: q.membre.urlImage,
              },
            };
           }else{
            return {
              quartierId: q.id,
              membre: {
                id:null,
                nom:q.membre.nom,
                prenom:q.membre.prenom,
                urlImage:q.membre.urlImage,
              },
            };
           }
          });

           const hasAssignments = quartiers.value.some(q => 
          q.selectedMembre || (q.membre.nom && q.membre.prenom)
        );

        if (!hasAssignments) {
          Swal.fire({
            title: "Veuillez assigner au moins un quartier à un membre",
            icon: "error",
            draggable: true,
          });
          return;
        }

          // Validate new members have required fields
                const invalidNewMembers = quartiers.value.filter(q => 
                  q.selectedMembre && parseInt(q.selectedMembre) < 0 && 
                  (!q.membre.nom || !q.membre.prenom)
                );
        
                if (invalidNewMembers.length > 0) {
                  Swal.fire({
                    title: "Tous les nouveaux membres doivent avoir un nom et un prénom",
                    icon: "error",
                    draggable: true,
                  });
                  return;
                }

        //   if (assignations.length === 0) {
        //   Swal.fire({
        //     title: "Veuillez assigner au moins un quartier a un membre",
        //     icon: "error",
        //     draggable: true,
        //   });
        //   return;
        // }
        //  payload["assignations"]= assignations
        //  payload["mandatureId"]= mandatureId

       
        // console.log("Payload envoyé :", payload);

         const formData = new FormData();

        // Toujours ajouter mandatureId et assignations
        formData.append('mandatureId', mandatureId.toString());
        formData.append('assignations', JSON.stringify(assignations));
        
        console.log('=== DONNÉES AVANT ENVOI ===');
        console.log('MandatureId:', mandatureId);
        console.log('Assignations data:', assignations);
        console.log('Quartiers avec fichiers:');
        quartiers.value.forEach(quartier => {
          if (quartier.membre.urlImage) {
            console.log(`  Quartier ${quartier.id}:`, {
              nom: quartier.membre.nom,
              prenom: quartier.membre.prenom,
              selectedMembre: quartier.selectedMembre,
              fileType: typeof quartier.membre.urlImage,
              fileName: quartier.membre.urlImage?.name || 'N/A'
            });
          }
        });

         // Ajouter les fichiers pour les nouveaux membres
        quartiers.value.forEach(quartier => {
          console.log(`Vérification quartier ${quartier.id}:`, {
            selectedMembre: quartier.selectedMembre,
            hasImage: !!quartier.membre.urlImage,
            imageType: typeof quartier.membre.urlImage,
            isFile: quartier.membre.urlImage instanceof File
          });
          
          if (quartier.selectedMembre && parseInt(quartier.selectedMembre) < 0 && quartier.membre.urlImage instanceof File) {
            formData.append(`image_${quartier.id}`, quartier.membre.urlImage, quartier.membre.urlImage.name);
            console.log(` Fichier ajouté pour chefquartier ${quartier.id}:`, quartier.membre.urlImage.name);
          } else if (quartier.selectedMembre && parseInt(quartier.selectedMembre) < 0) {
            console.log(`Quartier ${quartier.id} est un nouveau membre mais pas de fichier image valide`);
          }
        });

        console.log("FormData contents:");
        for (let [key, value] of formData.entries()) {
          console.log(key, value);
        }

        // Vérifier que FormData n'est pas vide
        const formDataEntries = Array.from(formData.entries());
        if (formDataEntries.length === 0) {
          console.error("FormData est vide!");
          Swal.fire({
            title: "Erreur: Aucune donnée à envoyer",
            icon: "error",
            draggable: true,
          });
          return;
        }
        ApiService.setHeader();
        console.log("=== DEBUG INFO ===");
        console.log("MandatureId:", mandatureId, "Type:", typeof mandatureId);
        console.log("Assignations:", assignations);
        console.log("FormData size:", formDataEntries.length);
        
        // Option 1: Essayer avec ApiService
        let response;
        try {
          console.log(" Tentative avec ApiService.postWithFile");
          response = await ApiService.postWithFile("/chefquartiermembre", formData);
          console.log("Succès avec ApiService:", response);
        } catch (apiError) {
          console.error(" Échec avec ApiService:", apiError);
          // Option 2: Essayer avec axios direct en cas d'échec
          console.log("Tentative avec axios direct...");
        }
        
        Swal.fire({
          title: "Assignations ajoutées avec succès",
          icon: "success",
          draggable: true,
        }).then(() => {
          router.push('/liste-chefquartier');
        });
        
        console.log("Réponse finale :", response.data);

        resetForm();
      }catch (error) {
        console.error("Erreur lors de l’envoi :", error);
        Swal.fire({
          title: "Tous les postes doivent être assignés",
          icon: "error",
          draggable: true,
        }).then(() => {
          router.push('/ajouter-chefquartier');
        });
      }
    }



     return {
      assignationSchema,
      assignationForm,
      submitAssign,
      arrondissementOptions,
      membresOptions,
      mandaturesOptions,
      selectedArrondissement,
      addNewMembre,
      onArrondissementChange,
      onImageChange,
      quartiers,
      nom,        // <-- ajouté
      prenom,     // <-- ajouté
      newImage,
     currentQuartierId
    };
  }
})
</script>